/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import PieChart from "examples/Charts/PieChart";

// Data
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchGenderRatio, fetchJoinedPerMonth, fetchSubscriptionPerMonth } from "services/apis";
import { transformGenderRatioData, transformJoinDataToChart, transformSubscriptionDataToChart } from "utils/formatData";

function AllGraphs() {
    const { sales, tasks } = {
        sales: {
            labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            datasets: { label: "Mobile apps", data: [50, 40, 300, 320, 500, 350, 200, 230, 500] },
        },
        tasks: {
            labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            datasets: { label: "Desktop apps", data: [50, 40, 300, 220, 500, 250, 400, 230, 500] },
        },
    };
    const [joinedData, setJoinedData] = useState(null);
    const [genderData, setGenderData] = useState(null);
    const [subscriptionData, setSubscriptionData] = useState(null);
   const navigate = useNavigate();
 
    useEffect(() => {
        const getData = async () => {
            try {
                const res = await fetchJoinedPerMonth();
                const genderRes = await fetchGenderRatio();
                const subscriptionRes = await fetchSubscriptionPerMonth();
                
                if (res?.success) {
                    const transformed = transformJoinDataToChart(res.data || []);
                    setJoinedData(transformed);
                }
                if (genderRes?.success) {
                    const genderTransform = transformGenderRatioData(genderRes.data || []);
                    setGenderData(genderTransform);
                }
                if (subscriptionRes?.success) {
                    const subscriptionTransform = transformSubscriptionDataToChart(subscriptionRes.data || {});
                    setSubscriptionData(subscriptionTransform);
                }
            } catch (err) {
                console.error("Error loading chart data:", err);
            }
        };

        getData();
    }, []);


    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>

                <MDBox mb={3} onClick={() => navigate(`/users`)} sx={{ cursor: "pointer" }}>
                    {joinedData &&
                        <ReportsBarChart
                            color="info"
                            title="Users Joined"
                            description="Monthly new user growth"
                            date="updated just now"
                            chart={joinedData}
                        />
                    }
                </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
                <MDBox mb={3}>
                    {subscriptionData &&
                        <ReportsLineChart
                            color="success"
                            title="Subscribers"
                            description="Monthly subscription growth"
                            date="updated just now"
                            chart={subscriptionData}
                        />
                    }
                </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
                <MDBox mb={3}>
                    {/* function PieChart({ icon, title, description, height, chart }) {
 */}
                    {genderData &&
                        <PieChart
                            icon={{ component: "pie_chart", color: "info" }}
                            title="User Gender Ratio"
                            description="Gender distribution of users"
                            height={220}
                            chart={genderData}
                        />
                    }
                    {/* <ReportsLineChart
          color="dark"
          title="completed tasks"
          description="Last Campaign Performance"
          date="just updated"
          chart={tasks}
        /> */}
                </MDBox>
            </Grid>
        </Grid>
    );
}

export default AllGraphs;
